import page_layout from '../assets/images/portfolio/page_layout.jpg'
import eidaladha_character7 from '../assets/images/portfolio/eidaladha_character7.jpg'
import merge from '../assets/images/portfolio/merge.jpg'
import manipulasi_1 from '../assets/images/portfolio/manipulasi_1.jpg'
import bag_2 from '../assets/images/portfolio/bag_2.jpg'
import cod from '../assets/images/portfolio/cod.jpg'
import kingedit from '../assets/images/portfolio/kingedit.jpg'
import lipstick from '../assets/images/portfolio/lipstick.jpg'
import smoothing3 from '../assets/images/portfolio/smoothing3.jpg'
import eidaladha_character8 from '../assets/images/portfolio/eidaladha_character8.jpg'
import eidaladha_character12 from '../assets/images/portfolio/eidaladha_character12.jpg'
import eidaladha_character14 from '../assets/images/portfolio/eidaladha_character14.jpg'
import move16 from '../assets/images/portfolio/move16.jpg'
import landing_page_1 from '../assets/images/portfolio/landing_page_1.jpg'
import landing_page_2 from '../assets/images/portfolio/landing_page_2.jpg'
import poster_1 from '../assets/images/portfolio/poster_1.jpg'
import feed_122220_2 from '../assets/images/portfolio/feed_122220_2.jpg'
import feed_122220_1 from '../assets/images/portfolio/feed_122220_1.jpg'
import feedig_3 from '../assets/images/portfolio/feedig_3.jpg'
import feedig_2 from '../assets/images/portfolio/feedig_2.jpg'
import feedig_1 from '../assets/images/portfolio/feedig_1.jpg'
import food_3 from '../assets/images/portfolio/food_3.jpg'
import food_2 from '../assets/images/portfolio/food_2.jpg'
import food_1 from '../assets/images/portfolio/food_1.jpg'
import quiz_1 from '../assets/images/portfolio/quiz_1.jpg'
import shapess_2 from '../assets/images/portfolio/shapess_2.jpg'
import fathersday17a from '../assets/images/portfolio/fathersday17a.jpg'
import sosmed_text from '../assets/images/portfolio/sosmed_text.jpg'
import sosmed6 from '../assets/images/portfolio/sosmed6.jpg'
import sosmed5_m from '../assets/images/portfolio/sosmed5_m.jpg'
import sosmed4_m from '../assets/images/portfolio/sosmed4_m.jpg'
import sosmed3_m from '../assets/images/portfolio/sosmed3_m.jpg'

// format
// {
//     title: '',
//         data: [
//         {
//             image: '',
//             description: '',
//             tools: []
//         }
//     ]
// }

// {
//     image: '',
//         description: '',
//     tools: [
//
// ]
// }

const EditingPortfolios = [
  {
    title: 'Photo Editing',
    data: [
      {
        image: page_layout,
        description: 'Make page layout design for annual book page. Include some photos and text and add effect into photos.',
        tools: ['Photoshop']
      },
      {
        image: merge,
        description: 'Merge 4 photos into one photo and edit them to realistic looks.',
        tools: ['Photoshop']
      },
      {
        image: manipulasi_1,
        description: 'Photo manipulation of client requests.',
        tools: ['Photoshop']
      },
      {
        image: bag_2,
        description: 'Bag product photo editing, the left is before editing and the right is after editing. Looks smoother.',
        tools: ['Photoshop']
      },
      {
        image: cod,
        description: "The editing of COD game wallpaper photo is changing the real head into someone else's head. See the difference.",
        tools: ['Photoshop']
      },
      {
        image: kingedit,
        description: 'Photo manipulation, the difference is visible by marked with a red circle.',
        tools: ['Photoshop']
      },
      {
        image: lipstick,
        description: 'Recoloring for pink lipstick products and add gloss to the lips.',
        tools: ['Photoshop']
      },
      {
        image: smoothing3,
        description: "Smoothes a woman's face.",
        tools: ['Photoshop']
      }
    ]
  },
  {
    title: 'Social Media',
    data: [
      {
        image: feed_122220_2,
        description: "Instagram puzzle feed for happy mother's day content.",
        tools: ['Photoshop', 'Canva']
      },
      {
        image: feed_122220_1,
        description: 'Instagram puzzle feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: feedig_3,
        description: 'Instagram for senior high school exam',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: feedig_2,
        description: 'Instagram feed for ramadhan',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: feedig_1,
        description: 'Instagram feed for happy ramadhan',
        tools: ['Photoshop']
      },
      {
        image: food_3,
        description: 'Instagram feed for restorant menu',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: food_2,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: food_1,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: quiz_1,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: shapess_2,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: fathersday17a,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: sosmed_text,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: sosmed6,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: sosmed5_m,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: sosmed4_m,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      },
      {
        image: sosmed3_m,
        description: 'Instagram feed example',
        tools: ['Photoshop', 'Canva']
      }
    ]
  },
  {
    title: 'Illustration',
    data: [
      {
        image: eidaladha_character7,
        description: 'Islamic themed banner background.',
        tools: ['Photoshop', 'Illustrator']
      },
      {
        image: eidaladha_character8,
        description: 'Islamic themed banner background.',
        tools: ['Illustrator']
      },
      {
        image: eidaladha_character12,
        description: 'Islamic themed banner background.',
        tools: ['Illustrator']
      },
      {
        image: eidaladha_character14,
        description: 'Islamic themed banner background.',
        tools: ['Illustrator']
      },
      {
        image: move16,
        description: 'Islamic themed banner background.',
        tools: ['Illustrator']
      },
      {
        image: landing_page_1,
        description: 'Christmas themed background for landing page.',
        tools: ['Illustrator']
      },
      {
        image: landing_page_2,
        description: '',
        tools: ['Illustrator']
      }
    ]
  },
  {
    title: 'Poster',
    data: [
      {
        image: poster_1,
        description: 'Posters about the importance of safety for tailors (in Indonesian).',
        tools: ['Photoshop', 'Canva']
      }
    ]
  }
]

export default EditingPortfolios
